module.exports = __webpack_public_path__ + "static/media/reusablesLogo2.86a77354.png";